import { signOut } from '../../services/auth'

export function AccessDenied() {
  const handleSignOut = async () => {
    await signOut()
    window.location.reload()
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background-secondary">
      <div className="text-center">
        <h1 className="font-heading text-4xl font-bold text-primary mb-4">Access Denied</h1>
        <p className="text-gray-600 mb-6">You do not have permission to access the admin panel.</p>
        <p className="text-sm text-gray-500 mb-6">Contact a super admin to request access.</p>
        <button
          onClick={handleSignOut}
          className="rounded-xl bg-primary px-6 py-2 text-white hover:bg-primary-dark transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  )
}
